<template>
  <div class="dashboard" >
    <v-container class="my-5">
      <v-layout wrap row justify-start class="mb-3">
        <v-flex xs12 md12 px-1>
          <v-text-field
            label="Search By Code, Company Code, Influencer..."
            solo
            v-model="searchText"
            @input="filterInvoices()"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <div v-if="loading" class="text-xs-center">
        <v-progress-linear :indeterminate="true"></v-progress-linear>
      </div>
      <v-layout row wrap py-3>
        <v-flex xs12 sm12 md12>
            <span> {{ filteredInvoices.length}} Results </span>
            <div class="text-xs-center">
              <v-pagination
                v-model="currentPage"
                :length="pagesNumber"
                :total-visible="5"
                @input="updateVisible"
              ></v-pagination>
            </div>
        </v-flex>
      </v-layout>
      <v-layout row wrap py-3>
        <v-flex xs12 sm12 md12 v-for="invoice in visibleInvoices" :key="invoice.key" mb-1>
          <v-card>
            <v-card-text>
              <v-layout row wrap align-center>
                <v-flex xs3>
                  <div style="font-size:11px;font-weight:600;">CODE</div>
                  <div class="subheadline">{{ invoice.code }}</div>
                </v-flex>
                <v-flex xs3>
                  <div style="font-size:11px;font-weight:600;">COMPANY</div>
                  <div class="subheadline">{{ invoice.company_code }}</div>
                </v-flex>
                <v-flex xs3>
                  <div style="font-size:11px;font-weight:600;">DATE</div>
                  <div class="subheadline">{{ invoice.date }}</div>
                </v-flex>
                <v-flex xs1>
                  <div style="font-size:11px;font-weight:600;">PAID</div>
                  <div class="subheadline">
                    <v-avatar
                      size="10"
                      :color="`${ invoice.paid ? 'success' : 'error' }`"
                    >
                    </v-avatar>
                  </div>
                </v-flex>
                <v-flex xs2>
                  <div style="font-size:11px;font-weight:600;">TOTAL</div>
                  <div class="subheadline">{{ invoice.total }}</div>
                </v-flex>
                <v-flex xs12 pt-3 style="font-weight:bold;">
                  ITEMS
                </v-flex>
                <v-flex xs12 pt-3>
                  <v-layout row wrap class="text-xs-left">
                    <v-flex xs3>
                      <div style="font-size:10px;font-weight:600;">CODE</div>
                    </v-flex>
                    <v-flex xs3 px-1>
                      <div style="font-size:10px;font-weight:600;">NAME</div>
                    </v-flex>
                    <v-flex xs3>
                      <div style="font-size:10px;font-weight:600;">QT.</div>
                    </v-flex>
                    <v-flex xs3 px-1>
                      <div style="font-size:10px;font-weight:600;">PRICE</div>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 v-for="(item, it) in invoice.items" py-1 :key="'item-'+it">
                  <v-layout row wrap class="text-xs-left">
                    <v-flex xs3>
                      {{item.code}}
                    </v-flex>
                    <v-flex xs3 px-1>
                      {{item.name}}
                    </v-flex>
                    <v-flex xs3>
                      {{item.quantity}}
                    </v-flex>
                    <v-flex xs3 px-1>
                      {{item.price}}
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions dense v-if="false">
              <v-spacer></v-spacer>
              <v-btn color="primary" dark small @click="goTo(`/issue-invoice/${invoice.key}`)">Edit</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout row wrap py-3>
        <v-flex xs12 sm12 md12>
          <div class="text-xs-center">
            <v-pagination
              v-model="currentPage"
              :length="pagesNumber"
              :total-visible="7"
              @input="updateVisible"
            ></v-pagination>
          </div>
        </v-flex>
      </v-layout>
      
    </v-container>
  </div>
</template>

<script>
import {firebase, db, auth, store} from '@/fb'
import { titleCase, randomString } from '@/customFunction'
import axios from 'axios';

export default {
  data() {
    return {
      searchText:'',
      loading:false,
      currentPage: 1,
      pageSize: 7,
      pagesNumber:0,
      invoices:[],
      filteredInvoices:[],
      visibleInvoices:[],
    }
  },
  props:{
    uid:{
      default:null
    }
  },
  methods:{
    goTo(path) {
      this.$router.push(path)
    },
		updateVisible() {
      this.sortByDate()
      this.visibleInvoices = this.filteredInvoices.slice((this.currentPage -1) * this.pageSize, ((this.currentPage -1) * this.pageSize) + this.pageSize);
      this.loading = false
    },
    sortByDate(){
      this.filteredInvoices = this.filteredInvoices
    },
    getPagesNumber(){
      if (this.filteredInvoices.length % this.pageSize == 0) {
        this.pagesNumber = parseInt(this.filteredInvoices.length / this.pageSize)
      } else {
        this.pagesNumber = parseInt(this.filteredInvoices.length / this.pageSize) + 1
      }
		},
		filterInvoices() {
      this.loading = true
			this.filteredInvoices = this.invoices.filter(x=>{
        if(this.searchText){
          this.searchText = this.searchText.toLowerCase()
          for (const key in x) {
            if (Object.hasOwnProperty.call(x, key) && typeof x[key] == 'string') {
              if(x[key] && x[key].toLowerCase().includes(this.searchText)) {
                return x
              }
            }
          }
        } else {
          return x
        }
      });
      this.getPagesNumber()
      this.currentPage = 1
			this.updateVisible()
		},
		clipboardSuccessHandler ({ value, event }){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    async genToken() {
      this.loading = true
      let c = await db.ref('settings/infInvoices').once('value').then(x=>x.val())
      let vtoken = `ASHYAAT_INVOICE_${randomString(4, 'aA#')}_${c}`
      this.token = vtoken
      this.loading = false
      return vtoken
    },
    async getInvoices(){
      this.loading = true
      let invoices = await store.collection(`invoices`).orderBy("date", "desc").get().then(x=>x.docs.map((y, i)=>{
        if(i==x.docs.length-1) this.last = y
        return {
          ...y.data(), 
          key:y.id,
        }
      }))
      console.log(invoices)
      this.invoices = invoices
      this.filterInvoices()
    },
  },
  watch:{
    
  },
  created(){
    this.getInvoices()
  }
}
</script>

<style>

</style>
